import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CampaignPostContentType } from "../../../shared/enums/campaignPost.enums";
import { BrandCampaign } from "../../../shared/models/brandCampaign";
import { BrandCampaignDetails } from "../../../shared/models/brandCampaignDetail";
import { BrandFacebookPostLog } from "../../../shared/models/brandFacebookPostLog";
import { PaymentType } from "../../../shared/enums/campaign.enums";
import { BrandPostLogWithAd } from "../../../shared/types/postLog.types";

export interface BrandCampaignAdData {
  readonly campaign: BrandCampaign;
  readonly campaignDetails: BrandCampaignDetails;
  readonly postLog: BrandPostLogWithAd;
}

export type BrandCampaignAdDialogData = BrandCampaignAdData;
export type BrandCampaignAdDialogResult = undefined;

@Component({
  selector: "app-brand-campaign-ad-dialog",
  templateUrl: "./brand-campaign-ad-dialog.component.html",
  styleUrls: ["./brand-campaign-ad-dialog.component.scss"],
})
export class BrandCampaignAdDialogComponent implements OnInit {
  public loading = false;
  public campaign: BrandCampaign;
  public campaignDetails: BrandCampaignDetails;
  public post: BrandPostLogWithAd;
  public mapRadius: number;
  public effectiveAdsStartDate: Date;
  public effectiveAdsEndDate: Date;
  public mapCenter: google.maps.LatLng;

  @ViewChild("scrollableArea") private scrollableArea!: ElementRef;

  public readonly PaymentType = PaymentType;
  public readonly ContentType = CampaignPostContentType;

  constructor(@Inject(MAT_DIALOG_DATA) data: BrandCampaignAdData) {
    this.campaign = data.campaign;
    this.campaignDetails = data.campaignDetails;
    this.post = data.postLog;
    this.effectiveAdsStartDate = this.post.ad.startDate;
    this.effectiveAdsEndDate = this.post.ad.endDate;
    this.mapRadius = this.post.ad.radius || 30; // `radius=0` is not accepted

    this.mapCenter = new google.maps.LatLng(
      parseFloat(this.post.ad.latitude + ""),
      parseFloat(this.post.ad.longitude + ""),
    );
  }

  public ngOnInit(): void {
    if (this.scrollableArea) {
      this.scrollableArea.nativeElement.scrollTop = 0;
    }

    setTimeout(() => {
      if (this.scrollableArea) {
        this.scrollableArea.nativeElement.scrollTop = 0;
      }
    }, 500);
  }

  public getCarouselFirstSlideUrl(): string {
    const facebookPost = this.post as BrandFacebookPostLog;
    if (facebookPost.carouselSlides[0]) {
      return facebookPost.carouselSlides[0].url;
    }
    return "";
  }

  public isAPostLogWithAlreadyPaidAd(): boolean {
    return this.post && this.post.hasAd && !!this.post.ad?.isPaidAd;
  }
}
